import { Link } from 'react-router-dom'

import { ListIcon, PanelLeftIcon, ToggleGroup } from '@buffer-mono/popcorn'

import { communityChannel, communityPage } from '~publish/legacy/routes'
import type { CommentsChannelView } from '~publish/legacy/routes'

import styles from './CommentsOrPostsViewToggle.module.css'

import type { JSX } from 'react'

export const CommentsOrPostsViewToggle = ({
  channelId,
  value,
  handleToggleGroupChange,
  className,
}: {
  channelId?: string
  value: CommentsChannelView
  handleToggleGroupChange: (value: string) => void
  className?: string
}): JSX.Element => {
  const getViewRoute = (view: CommentsChannelView): string => {
    if (!channelId) return communityPage.getViewRoute({ view })
    return communityChannel.getRoute({ channelId, view })
  }

  return (
    <ToggleGroup
      value={value}
      size="medium"
      onChange={handleToggleGroupChange}
      className={className}
    >
      <ToggleGroup.Item value="posts" asChild aria-label="Switch to posts view">
        <Link to={getViewRoute('posts')} tabIndex={0}>
          <PanelLeftIcon />
          <span className={styles.label}>By post</span>
        </Link>
      </ToggleGroup.Item>
      <ToggleGroup.Item
        value="comments"
        asChild
        aria-label="Switch to comments view"
      >
        <Link to={getViewRoute('comments')} tabIndex={0}>
          <ListIcon />
          <span className={styles.label}>List</span>
        </Link>
      </ToggleGroup.Item>
    </ToggleGroup>
  )
}
